// src/Components/Checkout/CheckoutForm.jsx
import React, { useState } from 'react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import './CheckoutForm.css';
import emailjs from '@emailjs/browser';

function CheckoutForm({ plan, price, clientInfo, onSuccess }) {
  const stripe = useStripe();
  const elements = useElements();

  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) return;

    setProcessing(true);
    setError(null);
    setSuccess(null);

    try {
      // Call your backend to create a PaymentIntent and get clientSecret
      const API_BASE_URL =
        window.location.hostname === 'localhost'
          ? 'http://localhost:5000'
          : 'https://shynegraphicsserver-qbn4ndyl.b4a.run';

      const res = await fetch(`${API_BASE_URL}/create-payment-intent`, {


        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          amount: price * 100,
          email: clientInfo.email,
          plan,
          clientName: clientInfo.name,
          business: clientInfo.business,
        }),

      });

      const { clientSecret } = await res.json();

      const cardElement = elements.getElement(CardElement);

      const { paymentIntent, error } = await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: cardElement,
        billing_details: {
          name: clientInfo.name,
          email: clientInfo.email,
        },
        },
      });

      if (error) {
        setError(error.message);
      } else if (paymentIntent.status === 'succeeded') {
        setSuccess(`Payment successful! ID: ${paymentIntent.id}`);

        // Send confirmation email via EmailJS
        emailjs.send(
          'service_5vjwi7v', // Your service ID
          'template_gq5upn9', // Your template ID
          {
            name: clientInfo.name,
            email: clientInfo.email,
            business: clientInfo.business,
            goals: clientInfo.goals,
            timeline: clientInfo.timeline,
            time: new Date().toLocaleString(),
          },
          process.env.REACT_APP_EMAILJS_PUBLIC_KEY // Your EmailJS public key
        ).then(
          (result) => {
            console.log('Email successfully sent!', result.text);
          },
          (error) => {
            console.error('EmailJS error:', error);
          }
        );

    if (onSuccess) onSuccess();
      }
    } catch (err) {
      setError('Something went wrong. Please try again.');
    }

    setProcessing(false);
  };

  return (
    <form onSubmit={handleSubmit} className="checkout-form">
      <h3>{plan}</h3>
      <p className="checkout-amount">
        Amount: <strong>${price}</strong>
      </p>

      <CardElement options={{ hidePostalCode: true }} />
      <button type="submit" disabled={!stripe || processing}>
        {processing ? 'Processing…' : 'Pay Now'}
      </button>

      {error && <div className="error-message">{error}</div>}
      {success && <div className="success-message">{success}</div>}
    </form>
  );
}

export default CheckoutForm;
